import { applianceType, battery, configured, lastSeen, mfgId, reachable } from '~/helpers/fields-description';
import { DevicesModule } from '~/store/modules/devices';
import { WirelessSwitch } from './WirelessSwitch.model';
import { WirelessSwitch3Buttons } from './WirelessSwitch3Buttons.model';

export class NLWO extends WirelessSwitch3Buttons {
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }

    get controlledDevice() {
        return (button: number) => {
            const device = DevicesModule.getDeviceById(`${this.id}#${button}`) as WirelessSwitch;
            return device?.endpoints[0]?.bindings;
        };
    }

    get shouldShowDevice() {
        return !this.deviceIdIncludesHash;
    }
}
